// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_AcceptancesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_AcceptancesResponse — POST /subscriptions/admin-terms/acceptances.
 */
import type { SubscriptionTerms_AcceptanceRow } from './SubscriptionTerms_AcceptanceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubscriptionTerms_AcceptancesResponseDados {
rows: SubscriptionTerms_AcceptanceRow[]
}

export type SubscriptionTerms_AcceptancesResponse = ApiResponse<SubscriptionTerms_AcceptancesResponseDados>;

registerResponseContract('SubscriptionTerms_AcceptancesResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: true },
      term_id:           { type: 'number',  required: false },
      franquia_id:       { type: 'number',  required: false },
      subscription_id:   { type: 'number',  required: false },
      franquia_nome:     { type: 'string',  required: false },
      termo_titulo:      { type: 'string',  required: false },
      termo_versao:      { type: 'string',  required: false },
      plan_id:           { type: 'number',  required: false },
      termo_plano:       { type: 'string',  required: false },
      termo_idioma:      { type: 'string',  required: false },
      term_variant_id:   { type: 'number',  required: false },
      content_sha256:    { type: 'string',  required: false },
      assinatura_sha256: { type: 'string',  required: false },
      assinatura_metodo: { type: 'string',  required: false },
      accepted_by_sub:   { type: 'string',  required: false },
      accepted_by_email: { type: 'string',  required: false },
      ip_address:        { type: 'string',  required: false },
      created_at:        { type: 'string',  required: false },
    },
  },
})
